<div class="scroll-display map-display">
    <form [formGroup]="mapForm">
      <div>
        <div class="title-conteiner">
          <p class="title">Valida la ubicacion de tu comercio</p>
        </div>
        <button class="close-btn" (click)="close()">X</button>
        <ng-container *ngIf="mapOptions.center && markerPosition && apiLoaded | async">
          <div class="map" [attr.data-testid]="'mapa'">
            <google-map
              (mapClick)="mapClick($event)"
              (zoomChanged)="zommChangedMap()"
              [options]="mapOptions"
              [zoom]="zoom"
              height="100%"
              width="100%"
            >
              <map-marker *ngIf="markerPosition" [position]="markerPosition" ></map-marker>
            </google-map>
          </div>
          <div *ngIf="mapOptions.center && markerPosition && !editingMarker" class="contenedor-botones">
            <div
            [attr.data-testid]="'warning-direccion-cobertura'"
            class="map-question parent-column"
            
          > 
            <span> ¿El marcador y la dirección no coinciden? </span>
            <a (click)="editingMarker = true">Ajustar</a>
          </div>
          <div class="contenedor">
            <button (click)="save()" mat-raised-button class="next-button" class="boton">Continuar</button>
          </div>
          </div>
         
          <div class="map-input-container" *ngIf="editingMarker">
            <div class="parent-column">
              <div class="parent">
                <div class="map-input-container-street">
                  <app-text-input
                    [attr.data-testid]="'direction'"
                    [placeholder]="'Calle'"
                    [labelText]="'Calle'"
                    formControlName="locationStreet"
                    [required]="true"
                    [submitted]="submitted || showErrorConfirm"
                  ></app-text-input>
                </div>
              </div>
            </div>
            <div class="parent-column-conteiner">
              <button (click)="confirm()" mat-raised-button class="buton-confirm">Confirmar</button>
            </div>
            <div [attr.data-testid]="'warning-direccion-cobertura'" class="map-state-warning" *ngIf="submitted">
              <span> Debe confirmar la dirección para continuar </span>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
  